module.exports = __webpack_public_path__ + "static/img/amz_img02.499f66a.png";


//////////////////
// WEBPACK FOOTER
// ./xcloud-client-components-web/images/common/amz_img02.png
// module id = oini
// module chunks = 66